import type { Ref } from 'vue';
import { ref } from 'vue';

import { BridgeInterface } from '#ui-shared/stores/app-bridge/bridge-interface';
import type { BridgeActions, BridgeState } from '#ui-shared/stores/app-bridge/types';

interface ChatBridgeActions extends BridgeActions {
  openConversation: (conversationId: string) => void | Promise<void>;
}

interface ChatBridgeState extends BridgeState {
  unreadCount: Ref<number>;
}

export class ChatBridgeInterface extends BridgeInterface<ChatBridgeActions, ChatBridgeState> {
  constructor() {
    super(
      {
        openConversation: async (conversationId: string) => {
          console.warn(
            `Chat bridge action 'openConversation' not (yet) registered. Conversation ID: ${conversationId}`,
          );
        },
      },
      {
        unreadCount: ref(0),
      },
    );
  }
}
